"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const amplitude_js_1 = __importDefault(require("amplitude-js"));
const analytics_1 = require("./analytics");
const envToAmplitudeApiKey = {
    development: '984a921fd48ec450c498260cd61439ba',
    staging: '984a921fd48ec450c498260cd61439ba',
    production: '5fcd7e5f6e1efb545d28cbac247de7ea'
};
class AmplitudeService {
    constructor() {
        this.isInitialized = false;
        this.amplitudeInstance = amplitude_js_1.default.getInstance();
    }
    get apiKey() {
        return this.options
            ? envToAmplitudeApiKey[this.options.environment]
            : undefined;
    }
    get logger() {
        var _a, _b;
        return (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.logger) !== null && _b !== void 0 ? _b : console;
    }
    initialize({ environment, getBaseAttributesFunc, enabled = true, logger }) {
        this.options = { environment, getBaseAttributesFunc, enabled, logger };
        if (!this.options.enabled) {
            return;
        }
        if (this.apiKey) {
            this.amplitudeInstance.init(this.apiKey, undefined, {
                apiEndpoint: 'amplitude-api.zencity.io'
            });
            this.isInitialized = true;
        }
    }
    setUserId(userId) {
        var _a;
        if (!((_a = this.options) === null || _a === void 0 ? void 0 : _a.enabled)) {
            return;
        }
        this.amplitudeInstance.setUserId(userId);
    }
    clearUser() {
        var _a;
        if (!((_a = this.options) === null || _a === void 0 ? void 0 : _a.enabled)) {
            return;
        }
        this.amplitudeInstance.setUserId(null);
        this.amplitudeInstance.regenerateDeviceId();
    }
    trackEvent(eventName, eventAttributes) {
        var _a, _b, _c;
        if (!((_a = this.options) === null || _a === void 0 ? void 0 : _a.enabled)) {
            this.logger.debug(`Reporting Amplitude event ${eventName}`, eventAttributes);
            return;
        }
        if (!this.isInitialized || !this.amplitudeInstance.getUserId()) {
            return;
        }
        try {
            this.amplitudeInstance.logEvent(eventName, Object.assign(Object.assign({}, eventAttributes), (_c = (_b = this.options) === null || _b === void 0 ? void 0 : _b.getBaseAttributesFunc) === null || _c === void 0 ? void 0 : _c.call(_b, analytics_1.AnalyticsServices.AMPLITUDE)));
        }
        catch (err) {
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            this.logger.error(`Error sending event '${eventName}' to Amplitude`, err);
        }
    }
}
exports.default = new AmplitudeService();
//# sourceMappingURL=amplitudeService.js.map